import CalendarIcon from "@mui/icons-material/CalendarTodayOutlined";
import { InputAdornment, MenuItem, Select } from "@mui/material";
import { convertISODate } from "@entrilia/shared/utilities/dateUtils";

interface Props {
  dates: string[];
  selectedDate: string | undefined;
  onDateChange: (date: string | undefined) => void;
  disabled?: boolean;
  fullWidth?: boolean;
}

const ReportingDateSelect = ({ dates, selectedDate, onDateChange, disabled, fullWidth }: Props) => {
  return (
    <Select
      value={selectedDate ?? ""}
      onChange={(e) => onDateChange(e.target.value || undefined)}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={{ minWidth: fullWidth ? undefined : "10rem" }}
      startAdornment={
        <InputAdornment position="start">
          <CalendarIcon />
        </InputAdornment>
      }
    >
      {dates.map((date) => (
        <MenuItem key={date} value={date}>
          {convertISODate(date)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default ReportingDateSelect;
